export const it = {
  invitation: {
    setPassword: {
      title: 'Completa la registrazione su Slash',
      subTitle: 'Imposta una password per accedere al tuo account.',
      fields: {
        password: 'Nuova password',
        passwordConfirm: 'Conferma password',
      },
      rules: {
        length: '8 caratteri',
        upper: '1 lettera maiuscola',
        lower: '1 lettera minuscola',
        digit: '1 numero',
      },
      errors: {
        mismatch: 'Le password non coincidono',
      },
      buttons: {
        submit: 'Conferma password',
      },
      success: {
        title: 'Registrazione completata',
        description:
          'La password è stata creata correttamente. Effettua la login con le nuove credenziali e inizia a esplorare la piattaforma',
        cta: 'Vai alla login',
      },
      error: {
        title: 'Si è verificato un errore',
        description:
          "L'impostazione della password non è andata a buon fine. Ti preghiamo di riprovare o contattarci",
        cta: 'Riprova',
      },
      tokenExpired: {
        title: 'Link non valido',
        description:
          "Il reindirizzamento alla pagina di impostazione password non risulta più valido. Se hai già settato la password precedentemente, accedi a Slash con le credenziali create. Altrimenti contatta l'Admin della piattaforma e richiedi un nuovo invito.",
        cta: 'Rigenera il token',
      },
    },
    confirmEmail: {
      success: {
        title: 'Mail verificata con successo',
        description:
          'La mail è stata verificata. Effettua la login con le tue credenziali e inizia a esplorare la nuova organizzazione',
        cta: 'Vai alla login',
      },
      error: {
        title: 'Si è verificato un errore',
        description:
          "La verifica dell'email non è andata a buon fine. Ti preghiamo di riprovare o contattarci.",
        cta: 'Riprova',
      },
      tokenExpired: {
        title: 'Link non valido',
        description:
          'Il link di verifica email non è più valido o è scaduto. Contatta il tuo Admin per ricevere un nuovo link.',
        cta: 'Vai alla login',
      },
    },
  },
};
